import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import { ignoreErrors } from '@/common/ignore/sentryError';
import { getStorage } from '@lhb/cache';
import router from '@/router/index';
/** 初始化 sentry */
export var initSentry = function () {
    if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_SENTRY_DSN) {
        Sentry.init({
            Vue: Vue,
            dsn: process.env.VUE_APP_SENTRY_DSN,
            environment: process.env.NODE_ENV,
            release: 'locationpms-pc@' + process.env.xClientVersion,
            integrations: [
                new BrowserTracing({
                    routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                    tracePropagationTargets: ['localhost', 'my-site-url.com', /^\//],
                }),
            ],
            // Set tracesSampleRate to 1.0 to capture 100%
            // of transactions for performance monitoring.
            // We recommend adjusting this value in production
            tracesSampleRate: 1.0,
            // 忽略无意义的错误
            ignoreErrors: ignoreErrors,
            beforeSend: function (event) {
                var _a, _b, _c, _d, _e;
                // console.log(`event`, event);
                // 如果 ignoreErrors 生效，不会走到这里，这里做兜底
                var eventExceptionMessage = Array.isArray((_a = event.exception) === null || _a === void 0 ? void 0 : _a.values) && ((_b = event.exception) === null || _b === void 0 ? void 0 : _b.values.length) ? (_e = (_d = (_c = event.exception) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.value : '';
                if (eventExceptionMessage && ignoreErrors.some(function (pattern) { return eventExceptionMessage.match(pattern); })) {
                    return null; // 返回null表示忽略该错误事件
                }
                // 排除依赖包本身的报错
                if (event.location && event.location.match(/\/node_modules\//gi)) {
                    return null;
                }
                // 排除地图本身的报错
                if (event.location && event.location.match(/https:\/\/webapi\.amap\.com/gi)) {
                    return null;
                }
                if (event.location && event.location.match(/map\.baidu\.com/gi)) {
                    return null;
                }
                // 排除静态资源包的报错
                if (event.location && event.location.match(/https:\/\/staticres\.linhuiba\.com\/libs/gi)) {
                    return null;
                }
                return event;
                // return null 会将此次上报丢弃
            }
        });
        // 上报用户信息
        try {
            var user_1 = getStorage('loginUserInfo');
            console.log('user', user_1);
            if (user_1) {
                Sentry.configureScope(function (scope) {
                    scope.setUser({
                        id: user_1.userId,
                        username: user_1.realname,
                    });
                });
            }
        }
        catch (e) {
            console.log(e);
        }
    }
};
